<template>
    <div class="column-layout">
        <div class="table-layout">
            <el-table :data="fileBizRecList" border style="width: 100%">
                <el-table-column prop="comName" label="公司名称" width="200" align="left"></el-table-column>
                <el-table-column prop="dispName" label="显示名称" width="200" align="left"></el-table-column>
                <el-table-column prop="extName" label="扩展名称" width="100" align="left"></el-table-column>
                <el-table-column prop="byteSize" label="文件大小（字节）" width="120" align="right"></el-table-column>
                <el-table-column prop="md5" label="MD5码" width="280" align="center"></el-table-column>
                <el-table-column prop="uuid" label="UUID" align="center"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import comnApi from '../../api/comn'

    export default {
        name: 'swb-repo-file-biz-rec',
        desc: '获取文件的变更记录',
        props: {
            uuid: {
                type: String,
            },
        },
        data: function () {
            return {
                fileBizRecList: [],
            }
        },
        created: function () {
            //
            this.getFileBizRecList();
        },
        methods: {
            getFileBizRecList: function () {
                let self = this;
                let postData = {};
                postData.uuid = self.uuid;
                let theLoad = MsgBox.loading();
                comnApi.getFileBizRecListByUuid(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        self.fileBizRecList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }

</script>




// WEBPACK FOOTER //
// src/compo/ctrl/RepoFileBizRec.vue